<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="desserts"
            :items-per-page="10"
            hide-default-footer
        >
            <template v-slot:item.status="{}">
                <v-btn rounded dense small class="green2" outlined color="primary">Active</v-btn>    
            </template>
        </v-data-table>
    </div>
</template>
<script>
import EPDService from "@/_services/EPDService";
import loadingMixin from "@/mixins/LoadingMixin";

export default {
    mounted() {
        this.startLoading()
        EPDService.getSingleEpdInfo(this.$route.params.geneticid, 'owner')
        .then(({data}) => {
            // console.log('res',data.ownerName)
            this.desserts[0].ownerName = data?.ownerName || '-'
        })
        .catch(e => {
            console.log('err', e)
        })
        .finally(() => {
            this.stopLoading()
        })
    },
    data() {
        return {
            desserts: [
                {
                    ownerName: '-',
                    ranch: '-',
                    dateOwned: '-',
                    percentOwnership: '-',
                    email: '-',
                    phone: '-',
                },
            ],
            headers: [
                {
                    text: this.$t('Owner Name'),
                    value: "ownerName",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                },
                {
                    text: this.$t('Ranch'),
                    value: "ranch",
                    sortable: false,
                    align: 'start',
                    class: "black--text ",
                    width: "10%"
                },
                {
                    text: this.$t('Date Owned'),
                    value: "dateOwned",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                },
                {
                    text: this.$t('Percent Ownership'),
                    value: "percentOwnership",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                },
                {
                    text: this.$t('Email'),
                    value: "email",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                },
                {
                    text: this.$t('Phone Number'),
                    value: "phone",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                },
            ],
        }
    },
    mixins: [loadingMixin]
}
</script>